<template>
    <div id="app" :class="'page_' + $route.name">
        <div id="header" class="font-title">
            <div class="c flex -align-start">
                <router-link to="/" class="logo boxshadow-l">
                    <img src="/img/logo.svg" class="-fullwidth" />
                </router-link>

                <span class="-flex-grow nav__show-hamburger"></span>

                <ul id="nav" :class="{ '-is-open': $store.state.app.nav_opened }" role="navigation" itemscope
                    itemtype="http://schema.org/SiteNavigationElement">
                    <li class="hamburger" @click="$store.commit('nav', { action: 'toggle' });">
                        <a href="javascript:void(0);">
                            <div><span class="fa">&#xf0c9;</span> {{ $t('menu.menu') }}</div>
                        </a>
                    </li>
                    <li class="link__home"><router-link to="/" exact>{{ $t('menu.home') }}</router-link></li>
                    <li><router-link to="/producten/products">{{ $t('menu.products') }}</router-link></li>
                    <!-- <li><router-link :to="{ name: 'home', hash: '#kings' }">{{ $t('menu.products') }}</router-link></li> -->
                    <li><router-link to="/overons/">{{ $t('menu.about') }}</router-link></li>
                    <li><router-link to="/vacatures/">{{ $t('menu.jobs') }}</router-link></li>
                    <li><router-link to="/contact/">{{ $t('menu.contact') }}</router-link></li>
                    <li v-if="cartQty.amount > 0">
                        <router-link to="/producten/cart/" class="text-lowercase">
                            {{ $t('products.cart') }}
                            <span class="bubble" v-if="cartQty.amount < 10">{{ cartQty.amount }}</span>
                            <span class="bubble" v-else>+</span>
                        </router-link>
                    </li>
                    <li v-if="!$store.getters['Auth/isAuthenticated']"><router-link to="/login/">{{ $t('menu.login')
                    }}</router-link></li>
                    <li v-else><router-link to="/logout/">{{ $t('menu.logout') }}</router-link></li>
                </ul>

                <span class="-flex-grow nav__hide-hamburger"></span>

                <div class="lang">
                    <div class="lang__current">
                        {{ $store.getters['Language/current'] }}
                    </div>
                    <ul id="lang">
                        <template v-for="lang in $store.getters['Language/others']">
                            <li :key="lang.id" @click="$store.dispatch('Language/set', lang.id)">
                                <a href="javascript:void(0);">{{ lang.id }}</a>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>

        <div id="main" role="main" class="clearfix">
            <router-view />
        </div>

        <section id="footer">
            <div class="c font-title">
                <div class="row">
                    <div class="hidden-sm-down col-md-4 col-lg-3 col-lg-offset-2 footer_img">
                        <img loading="lazy" :src="webdata('contact.afbeelding1')" class="-fullwidth boxshadow-m" />
                        <img loading="lazy" src="/img/logo.svg" class="footer_logo boxshadow" />
                    </div>
                    <div class="col-xs-12 col-md-6 col-md-offset-2 col-lg-6 col-lg-offset-1 footer_text">
                        <div class="hidden-md-up">
                            <img src="/img/crown.svg" class="hidden-md-up crown" /><br />
                        </div>
                        <div v-html="$options.filters.linkify(webdata('contact.contactinfo_footer', true))"></div>
                        <br />
                        <a href="/contact/" class="button boxshadow-l text-capitalize">{{ $t('menu.contact') }} &raquo;</a>
                    </div>
                </div>
                <br style="clear:both" /><br />
                <center>
                    <a href="/privacy/" class="button button_clear">{{ $t('menu.privacy') }} &raquo;</a>
                </center>
            </div>
        </section>

        <Toasts />
    </div>
</template>

<script>
export default {
    name: 'App',
    computed: {
        cartQty() {
            return this.$store.getters['Products/cartQty'];
        },
    },
    mounted() {
        this.$store.dispatch('Auth/startSession').finally(() => {
            this.$store.dispatch('Products/restoreCart');
        });
        this.$store.dispatch('getTexts');
        this.$store.dispatch('Language/init');
    },
    meta() {
        return this.$store.getters.meta;
    },
};
</script>

<style>
@import "assets/css/base.css";
@import "assets/css/layout.css";
@import "assets/css/products.css";
@import "assets/css/animations.css";
@import "assets/css/forms.css";
@import "assets/css/colors.css";
@import "assets/css/text.css";
@import "assets/css/header.css";
</style>
